<template>
  <v-menu v-model="menu" open-on-hover open-on-focus>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="materialCategoriesSelected"
        clearable
        chips
        multiple
        deletable-chips
        small-chips
        :items="materialCategoriesSelected"
        :loading="materialCategoriesLoading"
        :search-input.sync="materialCategoriesSearch"
        item-text="name"
        item-value="id"
        :label="noLabel ? '' : $t('MaterialCategory.title')"
        return-object
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="materialCategoriesSelected"
          :items="materialCategories"
          :search="materialCategoriesSearch"
          :filter="categoriesFilter"
          selection-type="independent"
          item-key="id"
          item-text="name"
          item-children="categories"
          open-all
          selectable
          selected-color="primary"
          hoverable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import MaterialCategories from "@/api/material_categories";

export default {
  name: "SearcherMaterialCategories",

  props: {
    value: Array,
    noLabel: Boolean,
  },

  computed: {
    categoriesFilter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getMaterialCategoriesFromAPI();
  },

  data: () => ({
    menu: false,
    materialCategories: [],
    materialCategoriesLoading: false,
    materialCategoriesSearch: "",
    materialCategoriesSelected: [],
  }),

  methods: {
    getMaterialCategoriesFromAPI() {
      this.materialCategoriesLoading = true;
      MaterialCategories.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materialCategories = response.data.categories;
              if (this.$route.query.category_id) {
                this.materialCategoriesSelected = [
                  this.$commonUtils.breadthQuery(
                    this.materialCategories,
                    this.$route.query.category_id,
                    "categories"
                  ),
                ];
              }
            }
            this.materialCategoriesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialCategoriesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.materialCategoriesSelected = this.value ? this.value : [];
      },
    },
    materialCategoriesSelected: {
      handler() {
        this.$emit("input", this.materialCategoriesSelected);
      },
    },
  },
};
</script>
